<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Настройки проектов
    v-col(cols="12")
      core-node(
        @edit="editProject"
        @delete="deleteProject"
        @open-create="dialog = true"
        add-title="Добавить проект"
        :loading="false"
        :items="projects"
      )
        template(#children="{ item, selected }")
          project-roles(
            v-if="selected === item.id"
            :project-id="selected"
          )

  v-dialog(v-model='dialog' max-width='500px' dark)
    v-card.pa-5
      p.text-h5 {{ title }}
      v-text-field(
        required
        v-model="form.name" filled label='Название проекта')
      v-btn.mr-4(
        :disabled="!form.name"
        color="success"
        @click="saveProject"
      ) Сохранить
      v-btn(text @click='dialog = false') Отменить

  smart-dialog(
    title="Действительно удалить проект?"
    ref="deleteProjectPopup"
    type="error"
  )

</template>

<script>
import { CRUDProjects } from '@/services/API/project';
import ProjectRoles from './components/ProjectRoles.vue';
import CoreNode from './components/CoreNode.vue';
import SmartDialog from '@/components/dialogs/SmartDialog.vue';

export default {
  components: { ProjectRoles, CoreNode, SmartDialog },
  data() {
    return {
      projects: [],
      dialog: false,

      form: {
        name: '',
      },

    };
  },
  computed: {
    title() {
      return this.form.id ? 'Изменение проекта' : 'Создание проекта';
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const params = {
        'per-page': -1,
        'sort': '-id',
      };

      try {
        const response = await CRUDProjects.getAll(params);
        this.projects = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async deleteProject(id) {
      const result = await this.$refs.deleteProjectPopup.open();

      if (!result) return;

      try {
        this.deleteProjectDialog = false;
        await CRUDProjects.delete(id);
        this.projects = this.projects.filter(({ id :projectId }) => projectId !== id);
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    editProject(data) {
      this.form = { ...data };
      this.dialog = true;
    },

    async saveProject() {
      this.dialog = false;

      if (this.form.id) {
        const response = await CRUDProjects.update(this.form.id, this.form);
        const index = this.projects.findIndex(({ id }) => id === this.form.id);
        const newProjects = [...this.projects];
        newProjects[index] = response.data.data;
        this.projects = newProjects;
      } else {
        const response = await CRUDProjects.create(this.form);
        this.projects.unshift(response.data.data);
      }
      this.form = { name: '' };
    },
  },
};
</script>
